import { DeprecatedCustomDownIcon, SelectedIcon } from '@lokalise/louis';

import styled, { css } from '@app/styled';
import { oneLineEllipsis } from '@app/styles';
import { modifier, spacing } from '@app/theme';

export const Container = styled.div`
    padding: ${spacing(1, 0)};
`;

export const BranchContainer = styled.div`
    max-height: 255px;
    overflow-y: auto;
`;

export const BranchNameText = styled.div`
    ${oneLineEllipsis};
    max-width: 300px;
    height: 100%;
`;

export const BranchSearchInputContainer = styled.div`
    padding: 5px 8px;
    width: 100%;
    min-width: 245px;
`;

export const StyledSelectedIcon = styled(SelectedIcon)`
    margin-right: 4px;
    flex: 0 0 auto;
`;

export const DownIcon = styled(DeprecatedCustomDownIcon)<{ $opened: boolean }>`
    transform: rotate(0deg);
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    ${modifier(
        '$opened',
        css`
            transform: rotate(180deg);
        `,
    )};
`;
